import React, { useState, useRef } from 'react';
import { FaUnlock } from 'react-icons/fa';
import { Row, Col } from 'react-bootstrap';
import { RCard, RIconText } from '@putil-view/item.components';
import {
	ScanLockerQrCode,
	RequestLockerByUuid,
	CaptureImageAndVideo,	
	DataForm,
	ConfirmForm,
	UploadUnlockData,
	DisplayResult
} from './components';
import 'css/qr-unlock.css';

const QrUnlock = () => {
	const uuid = useRef('');
	const [state, setState] = useState({
		result: null,
		scanText: '',
		lockerImage: '',
		lockerItems: '',
		lockerVideo: null,
		lockerVideoUrl: null,
		info: { cutPadlock: "", itemsFound: "" },
		data: [], stage: "SCAN_LOCKER_QR_CODE"
	})
	const onRestart = () => {
		[state.lockerImage, state.lockerItems,state.lockerVideo, state.lockerVideoUrl].forEach((blob) => {
			if (blob) {
				URL.revokeObjectURL(blob);
			}
		})
		uuid.current = '';
		setState({ result: null,
			scanText: '',
			lockerImage: '',
			lockerItems: '',
			lockerVideo: null,
			lockerVideoUrl: null,
			info: { cutPadlock: "", itemsFound: "" },
			data: [], stage: "SCAN_LOCKER_QR_CODE"})
	}

	return (
		<Row className="mt-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0 pr-0 align-self-start pt-4">
			<Col xl={12} lg={12} md={12} sm={12} xs={12} className="qr-unlock-col">
				<RCard title={
					<RIconText variant="lg">
						<FaUnlock />
						<span>Unlock Locker {state.scanText}</span>
					</RIconText>
				}>
					{state.stage === "SCAN_LOCKER_QR_CODE" &&
						<ScanLockerQrCode state={state} setState={setState} uuid={uuid} />
					}
					{state.stage === "REQUEST_LOCKER_BY_UUID" &&
						<RequestLockerByUuid setState={setState} uuid={uuid} />
					}
					{state.stage === "CAPTURE_IMAGES_AND_VIDEO" &&
						<CaptureImageAndVideo
							state={state}
							setState={setState}
							onRestart={onRestart}
						/>
					}
					{state.stage === "DATA_FORM" &&
						<DataForm state={state} setState={setState} />
					}
					{state.stage === "DATA_CONFIRM" &&
						<ConfirmForm state={state} setState={setState} onRestart={onRestart} />
					}
					{state.stage === "UPLOAD_UNLOCK_DATA" &&
						<UploadUnlockData state={state} setState={setState} uuid={uuid} />
					}
					{state.stage === "DISPLAY_RESULT" &&
						<DisplayResult state={state} onRestart={onRestart} />
					}
				</RCard>
			</Col>
		</Row>
	);
}
export default QrUnlock;
